import React, { FC, useEffect, useState } from "react";
import {
  Container,
  Form,
  Button,
  Card,
  Spinner,
  Modal,
  Row,
  Col,
  CardBody,
} from "react-bootstrap";
import { MdVideoLibrary } from "react-icons/md";
import { getHeaderTagsResponse } from "../../../services/getAiResponse";
import { HeaderTags } from "../types";
import { HelpModal } from "../../common/compoents/HelpModal";
import { IoMdPlay } from "react-icons/io";
import { ToolsHeader } from "../../components/ToolsHeader";
import { isInIframe } from "../../../utils/is-in-iframe";
import { Box } from "./headerTagsGenStyle";

type Props = {};
const helpSteps = [
  "Paste the content into the designated text area.",
  "Click 'Generate Tags' to generate the Heading Tags.",
];

export const HeaderTagsGenerator: FC<Props> = ({}) => {
  const [content, setContent] = useState<string>("");
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [generatedHeaders, setGeneratedHeaders] = useState<HeaderTags[]>([]);
  const [showHowToUse, setShowHowToUse] = useState<boolean>(false);
  const [showVideoModal, setShowVideoModal] = useState<boolean>(false);
  const [minLengthError, setMinLengthError] = useState<string | null>(null);

  const handleContentChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setContent(e.target.value);
  };
  useEffect(() => {
    const height = document.body.scrollHeight;
    window.parent.postMessage({ type: "setHeight", height }, "*");
  }, [generatedHeaders]);

  const handleGenerateTags = async () => {
    if (content.length < 100) {
      setMinLengthError("You need to enter at least 100 characters.");
      return;
    }

    setMinLengthError(null);
    setIsLoading(true);
    try {
      const response = await getHeaderTagsResponse(content);
      if (response) {
        setIsLoading(false);
        const data = JSON.parse(
          response.replaceAll("```json", "").replaceAll("```", "")
        );

        setGeneratedHeaders(data);
        const height = document.body.scrollHeight;
        window.parent.postMessage({ type: "setHeight", height }, "*");
        // console.log(response);
        // setGeneratedHeaders()
      }
    } catch (error) {
      console.error("Error generating headers:", error);
    }
    // setIsLoading(false);
  };

  const toggleHowToUse = () => {
    setShowHowToUse(!showHowToUse);
  };

  const openVideoModal = () => {
    setShowVideoModal(true);
  };

  const closeVideoModal = () => {
    setShowVideoModal(false);
  };

  const renderHeaders = (headers: HeaderTags[]) => {
    return (
      <ul>
        {headers.map((header, index) => (
          <li key={index}>
            {header.tag?.toUpperCase()}: <i> {header.headingName} </i>
            {header.children.length > 0 && renderHeaders(header.children)}
          </li>
        ))}
      </ul>
    );
  };

  return (
    <Box>
      <Row
        style={{ padding: isInIframe ? "0" : "10px" }}
        className={`${isInIframe && "interDisplay"}`}
      >
        <Col className="p-0">
          <HelpModal
            helpSteps={helpSteps}
            show={showVideoModal}
            close={closeVideoModal}
            videoUrl="https://www.youtube.com/embed/hNce9hFpBOY"
          />
          {!isInIframe && (
            <ToolsHeader
              title="Header Tags Generator"
              description="Smart tool to generate optimized H1, H2, H3 headings for your
                article or content with ease."
            />
          )}
          {/* <h1 className="text-center mb-3" style={{ fontWeight: 700 }}>
          Header Tags Generator
        </h1>
        <p className="text-center mb-4">
          The smartest tool to generate heading h1, h2, h3 for an article or
          content. Optimize header tags (H1, H2, H3, etc.) on targeted pages to
          improve SEO structure and enhance user experience.
        </p> */}
          {/* <div className="d-flex justify-content-center mb-4">
          <Button
            variant="outline-primary d-flex justify-content-center align-items-center"
            size="sm"
            onClick={openVideoModal}
          >
            See how to use <IoMdPlay className="ms-2" />
          </Button>
        </div> */}
          {/* <Button variant="outline-primary" size="sm" onClick={openVideoModal}>
            How to use <MdVideoLibrary className="ms-2" />
          </Button> */}
          <Card className="headerTagsCard">
            <Form>
              <Form.Group controlId="metaTagsInput">
                <Form.Label>Your Article</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={8}
                  placeholder="Paste the content of the article that you want to generate headings"
                  value={content}
                  onChange={handleContentChange}
                  style={{ resize: "vertical" }}
                  isInvalid={!!minLengthError}
                />
                <Form.Control.Feedback type="invalid">
                  {minLengthError}
                </Form.Control.Feedback>
              </Form.Group>

              <div className="text-center mt-4">
                {isLoading && (
                  <Spinner animation="border" role="status" className="spinner">
                    <span className="visually-hidden">Loading...</span>
                  </Spinner>
                )}

                {!isLoading && (
                  <Button
                    style={{backgroundColor:"#8cc540"}}
                    onClick={handleGenerateTags}
                    type="submit"
                  >
                    Genarate Tags
                  </Button>
                )}
              </div>
            </Form>
            {generatedHeaders.length > 0 && (
              <div className="mt-3">
                <Card className="resultCard">
                  <CardBody>
                    <h5>Generated Header Tags:</h5>
                    {renderHeaders(generatedHeaders)}
                  </CardBody>
                </Card>{" "}
              </div>
            )}
          </Card>
        </Col>
      </Row>
    </Box>
  );
};
